import { Box, Grid, Skeleton } from '@mui/material';

interface ProfilePageHeaderSkeletonProps {
  hideBtn?: boolean;
}
export const ProfilePageHeaderSkeleton: React.FC<ProfilePageHeaderSkeletonProps> = ({ hideBtn }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Grid container alignItems="center" justifyContent="space-between" spacing={1}>
        <Grid item>
          <Skeleton variant="rectangular" height="2.5rem" width="12.5rem" />
        </Grid>
        {!hideBtn && (
          <Grid item>
            <Skeleton variant="rectangular" height="3rem" width="7.5rem" />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
